/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:30 GMT
 */
const tokens = {
    component: {
        link: {
            color: {
                value: "#282e37",
                type: "color",
            },
            fontWeight: {
                value: 800,
                type: "number",
            },
            textDecoration: {
                value: "none",
                type: "string",
            },
            hover: {
                textDecoration: {
                    value: "underline",
                    type: "string",
                },
                color: {
                    value: "#464e53",
                    type: "color",
                },
            },
        },
    },
};
export default tokens;
